const getSessionId = () => {
  let sid = sessionStorage.getItem("e11_session");
  if (!sid) {
    sid = "s_" + Math.random().toString(36).slice(2) + Date.now();
    sessionStorage.setItem("e11_session", sid);
  }
  return sid;
};

export const trackEvent = (eventType, data = {}) => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");

    if (user?.role === "admin") return;

    fetch("https://eleven11-i6v4.onrender.com/api/analytics/event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
        eventType,
        sessionId: getSessionId(),
        userId: user?.id || "",
        userName: user ? `${user.firstName} ${user.lastName}` : "",
        listingId: data.listingId || "",
        listingTitle: data.listingTitle || "",
        metadata: {
          ...data,
          listingId: undefined,
          listingTitle: undefined
        }
      })


    }).catch(() => {});
  } catch {
    // silent
  }
};